module.exports = __webpack_public_path__ + "static/Flavor_18AMT90227-396e29687e545a188da1363cc19acd89.pdf";